"use client";
import { useEffect, useState } from "react";
import Select from "react-select";

const FilterMultiSelectHome = ({ data, placeholder, handleChange, propsStyle, controlStyles }) => {
  const [isClient, setIsClient] = useState(false);

  const optionsCategory = data.map((item) => ({
    value: item.id_category,
    label: item.title,
  }));
  const optionsCities = data.map((item) => ({
    value: item.id_villes,
    label: item.title,
  }));

  const options = placeholder == "Villes" ? optionsCities : optionsCategory;
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <Select
      options={options}
      placeholder={placeholder}
      onChange={handleChange}
      key={options.length}
      styles={{
        container: (provided) => ({
          ...provided,
          ...propsStyle
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          ...controlStyles,
        }),
      }}
    />

  );
};

export default FilterMultiSelectHome;
